import dayjs from 'dayjs'
import { setCookie, getCookie } from 'cookies-next'
import { jwtDecode } from 'jwt-decode'
import { authApi } from '@/api/auth'

export const baseURL = process.env.NEXT_PUBLIC_CRUZ_API_URL

// *** DELETE
export const defaultPostHeader = {
  'Accept': '*/*',
  'Content-Type': 'application/json'
}

export async function fetchHeaders(isFormData = false) {
  try {
    let accessToken = await getAccessToken()
    if (accessToken) {
      const d = jwtDecode(accessToken)
      if (d?.exp && dayjs().isAfter(dayjs.unix(d?.exp))) {
        accessToken = await getAccessToken()
      }
      if (isFormData) {
        return {
          'Accept': '*/*',
          'Authorization': `Bearer ${accessToken}`
        }
      }
      return { ...defaultPostHeader, 'Authorization': `Bearer ${accessToken}` }
    }
    return defaultPostHeader
  } catch {
    return defaultPostHeader
  }
}

export function formatFetchError(err: any) {
  const x = {
    status: err?.status || 500,
    message: err?.response?.data?.message || err?.message || 'Unknown error',
  }
  return x
}

export async function getAccessToken(): Promise<string | null> {
  try {
    if (typeof window === 'undefined') {
      // server - access token renewed in the middleware
      const { cookies } = await import('next/headers')
      const accessToken = await getCookie('access_token', { cookies })
      return Promise.resolve(accessToken || null)
    }

    // client
    const existAccessToken = getCookie('access_token') as string | null
    if (existAccessToken) {
      return Promise.resolve(existAccessToken)
    }
    const refreshToken = getCookie('refresh_token') as string
    if (!refreshToken) {
      return Promise.resolve(null)
    }
    const accessToken = await authApi.renewAccessToken(refreshToken)
    if (accessToken) {
      setCookie('access_token', accessToken, { expires: getTokenExp(accessToken) })
      return Promise.resolve(accessToken)
    }
    return Promise.resolve(accessToken)
  } catch (err) {
    return Promise.reject(err)
  }
}

function getTokenExp(token: string): Date {
  const decoded = jwtDecode(token)
  if (!decoded.exp) {
    return new Date()
  }
  return new Date(decoded.exp * 1000)
}